import { useCallback, useEffect, useState } from "react";

const STORAGE_KEY = "bookmarkedProducts";
const EVENT_NAME = "bookmarks:changed";

function readFromStorage() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

function writeToStorage(list) {
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(list));
  window.dispatchEvent(new CustomEvent(EVENT_NAME, { detail: list }));
}

export default function useBookmarks() {
  const [bookmarks, setBookmarks] = useState(readFromStorage);

  useEffect(() => {
    const sync = () => setBookmarks(readFromStorage());
    window.addEventListener(EVENT_NAME, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(EVENT_NAME, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const isBookmarked = useCallback(
    (productId) => bookmarks.some((p) => p.post_id === productId),
    [bookmarks]
  );

  const toggle = useCallback((product) => {
    setBookmarks((prev) => {
      const exists = prev.some((p) => p.post_id === product.post_id);
      const updated = exists
        ? prev.filter((p) => p.post_id !== product.post_id)
        : [...prev, product];
      writeToStorage(updated);
      return updated;
    });
  }, []);

  const remove = useCallback((product) => {
    setBookmarks((prev) => {
      const updated = prev.filter((p) => p.post_id !== product.post_id);
      writeToStorage(updated);
      return updated;
    });
  }, []);

  return { bookmarks, isBookmarked, toggle, remove };
}
